import { useConfigurations } from '../../components/shared/useConfigurations';
import { ConfigurationName } from '../../enums/ConfigurationName';

const useCurrencyCodeConfiguration = () => {
  const { getConfigurationValue } = useConfigurations();
  const currencyCode = getConfigurationValue(ConfigurationName.CurrencyCode) ?? 'GBP';

  const getCurrencyCodeConfiguration = (): void => undefined;

  return {
    currencyCode,
    getCurrencyCodeConfiguration,
  };
};

export default useCurrencyCodeConfiguration;